import { Injectable } from '@angular/core';
import { ModalController } from 'ionic-angular';

import { ObservationModalPage } from '../../pages/measure-input/observation-modal/observation-modal';

import { MeasureInputService } from './measure-input.service';
import { MeasureLocalService } from './local-data-services/measure-local.service';

import { Measure, Observation, ObservationType } from '../models/models';

@Injectable()
export class ObservationService {

  constructor(private measureInputService: MeasureInputService,
              private measureLocalService: MeasureLocalService,
              private modalCtrl: ModalController) {
  }

  public showObservation(impossible: boolean) {
    let measure = MeasureInputService.getCurrentMeasure();
    let observationModal = this.modalCtrl.create(
      ObservationModalPage,
      {
        observation: measure.observation,
        impossible: impossible
      },
      {
        cssClass: 'observation-modal',
        enableBackdropDismiss: false
      }
    );

    observationModal.onDidDismiss(
      (observation: Observation, role: string) => {
        if (role === 'confirm') {
          measure.observation = observation;
        } else if (role === 'confirm-impossible') {
          measure.observation = observation;
          measure.isImpossible = true;
        } else if (role === 'delete') {
          measure.observation = new Observation();
        }
        this.measureInputService.updateCurrentMeasure(measure);
        this.measureLocalService.findByPk(MeasureInputService.getCurrentPk())
          .subscribe((storedMeasure: Measure) => {
            if (!storedMeasure.isEmpty() || role === 'confirm-impossible') {
              this.measureLocalService.put(measure.setNewDate());
            }
          });
      }
    );

    observationModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/observation.service.ts